"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _billboard = require("billboard.js");

var _react = _interopRequireDefault(require("react"));

var _excluded = ["forwardRef", "elementProps"],
    _excluded2 = ["data", "onafterinit"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useIsomorphicLayoutEffect = typeof window === 'undefined' ? _react.default.useEffect : _react.default.useLayoutEffect;

var BillboardWrapper = function BillboardWrapper(_ref) {
  var forwardRef = _ref.forwardRef,
      _ref$elementProps = _ref.elementProps,
      elementProps = _ref$elementProps === void 0 ? {} : _ref$elementProps,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var elementRef = _react.default.useRef(null);

  var updateChart = _react.default.useCallback(function (args) {
    var data = args.data,
        _onafterinit = args.onafterinit,
        otherArgs = _objectWithoutProperties(args, _excluded2);

    if (elementRef.current) {
      if (!forwardRef.current) {
        forwardRef.current = _billboard.bb.generate(_objectSpread({
          bindto: elementRef.current,
          data: data,
          onafterinit: function onafterinit() {
            if (_onafterinit) {
              // Called async so that `forwardRef.current`
              // will be set to the chart before calling
              // `onafterinit`
              setTimeout(function () {
                return _onafterinit();
              }, 0);
            }
          }
        }, otherArgs));
      }

      forwardRef.current.load(data);
    }
  }, []);

  useIsomorphicLayoutEffect(function () {
    requestAnimationFrame(function () {
      return updateChart(otherProps);
    });
    return function () {
      if (forwardRef.current) {
        try {
          forwardRef.current.destroy();
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Internal billboard.js error', error);
        }
      }

      forwardRef.current = null;
    };
  }, []);
  useIsomorphicLayoutEffect(function () {
    updateChart(otherProps);
  }, [otherProps]);
  return /*#__PURE__*/_react.default.createElement("div", _extends({}, elementProps, {
    ref: elementRef
  }));
};

var _default = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  return /*#__PURE__*/_react.default.createElement(BillboardWrapper, _extends({
    forwardRef: ref
  }, props));
});

exports.default = _default;